import { convertDateToFormat } from "../../components/utils/utils";
import { getEmptyDateRange } from "./constants";

export const getDefaultMonthRange = () => {
  const currentDate = new Date();
  const pad = (value) => String(value).padStart(2, "0");
  const format = (date) =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return {
    startDate: format(currentDate),
    endDate: format(currentDate),
  };
};

export const toDateRangeValue = (date) => {
  if (!date?.startDate) return getEmptyDateRange();
  return {
    startDate: convertDateToFormat(date.startDate),
    endDate: convertDateToFormat(date.endDate),
  };
};

export const isSameDateRange = (left, right) =>
  left?.startDate === right?.startDate && left?.endDate === right?.endDate;

export const buildCdpFilterPayload = (filters, dateValue) => ({
  product_id: filters.domain?.id?.toString() || null,
  registration_device: filters.platform?.slug || null,
  start_date: dateValue?.startDate || null,
  end_date: dateValue?.endDate || null,
});

// Utility function for customer filters - KB
export const buildCustomerFilterPayload = (filters) => ({
  searchBy: filters.searchBy || "id",
  searchTerm: filters.searchTerm || "",
});

export const buildSubscriptionFilterPayload = (filters) => ({
  searchBy: filters.searchBy || "date",
  productFilter: filters.productFilter || "",
  platformFilter: filters.platformFilter || "",
  planFilter: filters.planFilter?.id || filters.planFilter || "",
  searchTerm: filters.searchTerm || "",
});

export const triggerFileDownload = (url, fileName) => {
  const link = document.createElement("a");
  link.setAttribute("hidden", "");
  link.setAttribute("href", url);
  link.setAttribute("download", fileName || "download.csv");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
